var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch",class:{'switch--on': _vm.value, 'switch--disabled': _vm.disabled},on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"switch__knob",class:{'switch__knob--on': _vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }